module.exports = __webpack_public_path__ + "media/images/services-img-2-516edd702492af408e68f49817ed98f9.png";